export const CUSTOMIZER_SPRING = {
	type: "spring",
	stiffness: 210,
	damping: 26,
	mass: 0.6,
} as const;

export const CUSTOMIZER_REDUCED_TRANSITION = { duration: 0 } as const;
